import { Box, Button, Modal, Stack, Tooltip } from "@mui/material";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
};

const ErrorBox = (props) => {
	const closeErrorBoxHandler = () => {
		props.setErrorState(false);
	};
	
	return (
		<Box
			onKeyDown={(e) => {
				if (!props?.buttonText && e.code === "KeyC") {
					closeErrorBoxHandler();
				}else if(e.code === `Key${props?.buttonText[0]}`){
					closeErrorBoxHandler();
				}
			}}
		>
			<Modal
				open={props.ErrorState}
				onClose={closeErrorBoxHandler}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				disableScrollLock
			>
				<Box sx={style}>
					<Stack mb={2} spacing={2}>
						{props.msg}
					</Stack>
					<Tooltip title={!props.buttonText ? "Press C to close" : `Press ${props?.buttonText[0]} to ${props.buttonText}`}>
						{!props.buttonText ? <Button onClick={closeErrorBoxHandler}>
							<u style={{textDecorationThickness: "2.5px", fontWeight: "bold"}}>C</u>lose
						</Button> :
						<Button onClick={closeErrorBoxHandler}>
							<u style={{textDecorationThickness: "2.5px", fontWeight: "bold"}}>{props?.buttonText[0]}</u>{props?.buttonText?.slice(1)}
						</Button>
						}
					</Tooltip>
				</Box>
			</Modal>
		</Box>
	);
};

export default ErrorBox;
